import Gauge from 'pages/Registration/Register/gauge-chart';
import { Grid } from '@material-ui/core';
import * as React from 'react';
import { connect } from 'react-redux';
import * as registrationDispatch from 'redux/ducks/registration';
import NumberInput from 'components/Input/NumberInput';
import { NumberFormatValues } from 'react-number-format';
import { RootState } from 'redux/rootReducer';
import { ThunkDispatch } from 'redux-thunk';
import { RegistrationActions } from 'redux/ducks/registration';

type StoreProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;

interface ComponentProps extends StoreProps, DispatchProps {}

type ScaleWeightMessage = {
  connectionType?: string;
  isMessage?: boolean;
  weight: number;
};

export function handleScaleWeightMessage(options: {
  eventData: ScaleWeightMessage;
  canUseBluetooth: boolean;
  setWeight: (weight: number) => void;
}) {
  const { eventData, canUseBluetooth, setWeight } = options;
  const isMessageViaBLE = 'connectionType' in eventData && eventData.connectionType === 'BLE';

  // For Bluetooth messages, we only allow them if the user has enabled Bluetooth in FoodWaste Settings
  if ((isMessageViaBLE && canUseBluetooth) || !isMessageViaBLE) {
    if ('isMessage' in eventData && !eventData.isMessage) {
      setWeight(eventData.weight);
    }
  }
}

export const WeightHandlerComponent: React.FC<ComponentProps> = (props) => {
  const {
    setWeight,
    weight,
    massUnit,
    canUseBluetooth,
    isScaleConnected,
    multipleRegistrationsDone
  } = props;

  const onValueChange = (values: NumberFormatValues) => {
    setWeight(values.floatValue);
  };

  const onReceivePostMessage = (
    event: MessageEvent<{ connectionType?: string; isMessage?: boolean; weight: number }>
  ) => {
    if (!event?.data || typeof event.data !== 'object') return;

    handleScaleWeightMessage({
      eventData: event.data,
      canUseBluetooth,
      setWeight
    });
  };

  React.useEffect(() => {
    window.addEventListener('message', onReceivePostMessage);
    return () => {
      window.removeEventListener('message', onReceivePostMessage);
    };
  }, [canUseBluetooth, setWeight]);

  return (
    <Grid item xs={12} className='weight-container'>
      <Grid item xs={12} className='gauge-container'>
        <Gauge value={weight} />
      </Grid>

      <Grid item xs={12} className='double-pair-container'>
        {
          <NumberInput
            className='number-input'
            value={weight ?? ''}
            allowEmptyFormatting
            type={'text'}
            required={!multipleRegistrationsDone}
            suffix={` ${massUnit}`}
            onValueChange={onValueChange}
            allowNegative={false}
            id='weight'
            name='weight'
            autoComplete='off'
            disabled={isScaleConnected}
            autoFocus={!isScaleConnected}
          />
        }
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state: RootState) => ({
  isScaleConnected: state.registration.scaleStatus.isConnected,
  weight: state.registration.weight,
  massUnit: state.settings.unit,
  canUseBluetooth: state.settings.canUseBluetooth,
  multipleRegistrationsDone:
    state.registration.allRegistrationPointsAreHandled &&
    state.registration.currentRegistrations.length > 0
});

const mapDispatchToProps = (dispatch: ThunkDispatch<RootState, void, RegistrationActions>) => ({
  setWeight: (weight: number) => {
    dispatch(registrationDispatch.setWeight(weight));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(WeightHandlerComponent);
